var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartupSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 489.24 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-11,.cls-9{fill:#d6d8e5;}.cls-1{opacity:0.15;}.cls-2,.cls-3{fill:#edeff9;}.cls-2{opacity:0.5;}.cls-4{fill:#ffbc00;}.cls-5{fill:#2f55d4;}.cls-6{fill:#424956;}.cls-7{fill:#494949;}.cls-8{fill:#2b303f;}.cls-9{opacity:0.4;}.cls-10{fill:#b1b4c4;}.cls-12{fill:#9ea1af;}.cls-13{fill:#c4c7d6;}.cls-14{fill:#e4e7f2;}.cls-15{fill:#fff;}.cls-16{fill:#e9eaf2;}.cls-17{fill:#f5f6ff;}.cls-18,.cls-19{fill:none;stroke:#e9eaf2;stroke-miterlimit:10;}.cls-18{stroke-width:0.31px;}.cls-19{stroke-width:1.53px;}.cls-20{fill:#edf0f9;}.cls-21{fill:#e2e5f2;}.cls-22{fill:#1c327d;}.cls-23{fill:#1c327d;}.cls-24{fill:#ffcea9;}.cls-25{fill:#ededed;}.cls-26{fill:#1c327d;}.cls-27{fill:#38477b;}.cls-28{fill:#f4f4f4;}.cls-29{fill:#2f55d4;}.cls-30{isolation:isolate;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Startup_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 71.93,
    cy: 322.02,
    rx: 71.93,
    ry: 41.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 71.1,
    cy: 317.58,
    rx: 40.12,
    ry: 23.16
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 70.72,
    cy: 309.36,
    rx: 11.44,
    ry: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 60.1,
    y: 221.73,
    width: 22,
    height: 86.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.05,220.75s.6,17.78,13.25,49.67c0,0,11.78-25.68,13-50.21S59.05,220.75,59.05,220.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "43.6 153.81 14.33 182.29 10.85 219.48 46.25 201.73 52.69 156.37 43.6 153.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "101 153.81 130.26 182.29 133.75 219.48 98.22 200.5 91.91 156.37 101 153.81"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 71.93,
    cy: 216.84,
    rx: 14.55,
    ry: 8.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "49.87 208.44 49.87 200.88 93.94 200.88 93.94 208.72 49.87 208.44"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 71.93,
    cy: 208.43,
    rx: 22.06,
    ry: 12.74
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 71.86,
    cy: 196.96,
    rx: 26.92,
    ry: 15.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.93,169.28h0c0,1.25,0,2.48,0,3.67,0,1,0,2,0,3,0,1.35-.07,2.64-.12,3.9,0,1.57-.11,3.06-.19,4.49s-.15,2.83-.25,4.12c-.41,5.65-.4,9.81-1.1,11.44-3.81,8.91-16.7,4-23.06.8-2.35-1.18-3.9-2.15-3.9-2.15h-.58s-1.84,1-4.56,2.08c-6.67,2.7-18.56,7.49-21.86-.76-.59-1.48-1.18-6.37-1.54-11.49-.09-1.28-.17-2.65-.25-4.11s-.12-2.91-.18-4.48c0-1.25-.07-2.54-.1-3.88,0-1,0-2,0-3h0l0-3.67h0c-.18-34.89,3.52-90.68,15.74-114.49,3.53-6.89,7.77-11.1,12.84-11.35v0h.58v0c5,.26,9.29,4.45,12.83,11.31C97.28,78.43,101.15,134,100.93,169.28Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 72,
    cy: 126.21,
    r: 10.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M72,137.87a11.66,11.66,0,1,1,11.66-11.66A11.67,11.67,0,0,1,72,137.87Zm0-20.34a8.68,8.68,0,1,0,8.67,8.68A8.69,8.69,0,0,0,72,117.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 72,
    cy: 96.31,
    r: 10.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M72,108A11.67,11.67,0,1,1,83.66,96.31,11.68,11.68,0,0,1,72,108Zm0-20.34a8.68,8.68,0,1,0,8.67,8.67A8.68,8.68,0,0,0,72,87.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100.93,189.39c0,1.25,0,2.48,0,3.68-1,3.3-3.72,6.46-8.14,9-11.46,6.61-30,6.61-41.51,0-4.42-2.56-7.13-5.73-8.14-9h0l0-3.67c1,3.36,3.7,6.56,8.18,9.15,11.47,6.61,30.05,6.61,41.51,0C97.22,195.93,100,192.74,100.93,189.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100.84,195.21c0,1.34-.07,2.64-.12,3.89-1.12,3.12-3.78,6.09-8,8.51-11.46,6.62-30,6.62-41.51,0-4.21-2.44-6.87-5.43-8-8.57,0-1.25-.07-2.54-.1-3.87,1,3.26,3.73,6.36,8.09,8.88,11.47,6.62,30.05,6.62,41.51,0C97.09,201.54,99.79,198.45,100.84,195.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100.53,184.88c-1.21,2.93-3.81,5.72-7.78,8-11.46,6.61-30,6.61-41.51,0-4-2.32-6.6-5.12-7.81-8.08.08,1.46.16,2.83.25,4.11,1.29,2.76,3.81,5.36,7.56,7.53a39.77,39.77,0,0,0,15.84,4.72,50.54,50.54,0,0,0,9,.07,40.14,40.14,0,0,0,16.63-4.79c3.72-2.15,6.23-4.72,7.53-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.05,54.73a44.73,44.73,0,0,1-26.25,0c3.53-6.89,7.77-11.1,12.84-11.35v0h.58v0C77.27,43.68,81.51,47.87,85.05,54.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 69.8,
    y: 153.89,
    width: 4.99,
    height: 65.51
  }), /*#__PURE__*/React.createElement("g", {
    id: "monitor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M311.4,382.18l-58-33.49c-4.19-2.42-3.66-6.64,1.17-9.43l37.58-21.69,73.15,42.23-37.58,21.7C322.88,384.29,315.58,384.59,311.4,382.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M315.63,379.69l-58-33.5c-4.18-2.41-3.66-6.63,1.17-9.42l37.59-21.69,73.15,42.23L332,379C327.12,381.8,319.81,382.1,315.63,379.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "369.53 357.31 369.53 355.1 366.15 357.05 369.53 357.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "254.8 342.2 254.8 339.95 258.27 341.39 254.8 342.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M315.63,377.47l-58-33.49c-4.18-2.42-3.66-6.63,1.17-9.42l37.59-21.7,73.15,42.24L332,376.79C327.12,379.58,319.81,379.89,315.63,377.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "296.57 312.96 287.52 282.92 361.47 325.34 369.53 355.1 296.57 312.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M367.39,356.33l2.14-1.23-3.19-2.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "294.24 314.09 285.19 284.05 359.14 326.47 367.38 356.33 294.24 314.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M482,407,195.71,241.69c-4-2.32-7.27-8.54-7.27-13.89V6.37c0-5.36,3.26-7.82,7.27-5.5L482,166.14c4,2.32,7.27,8.54,7.27,13.89V401.46C489.24,406.81,486,409.27,482,407Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "483.44 409.24 486.61 407.41 485.24 398.01 483.44 409.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M187.93,2.24,191.05.43,195.54,3s-4.78.73-4.9.7S187.93,2.24,187.93,2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M479.34,408.47,193.09,243.2c-4-2.32-7.27-8.53-7.27-13.89V7.88c0-5.35,3.25-7.81,7.27-5.49L479.34,167.66c4,2.32,7.27,8.54,7.27,13.89V403C486.61,408.33,483.36,410.79,479.34,408.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M478.84,408.76,192.58,243.49c-4-2.32-7.27-8.54-7.27-13.89V8.17c0-5.35,3.26-7.81,7.27-5.49L478.84,168c4,2.31,7.27,8.53,7.27,13.89V403.26C486.11,408.62,482.85,411.08,478.84,408.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M482.17,395.29,189,226,189.1,9.06c0-2.22,1.56-3.12,3.48-2L478.84,172.32a7.7,7.7,0,0,1,3.48,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M304.72,102.08,210.8,47.86a3.42,3.42,0,0,1-1.42-2.73V38.58c0-1,.63-1.53,1.42-1.08l93.92,54.22a3.45,3.45,0,0,1,1.42,2.73V101C306.14,102.05,305.5,102.54,304.72,102.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M280.6,103.65,211.23,63.6a3.4,3.4,0,0,1-1.43-2.72V57.62c0-1,.64-1.54,1.43-1.08L280.6,96.59A3.41,3.41,0,0,1,282,99.31v3.26C282,103.62,281.38,104.11,280.6,103.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M280.6,116,211.23,76a3.4,3.4,0,0,1-1.43-2.72V70c0-1,.64-1.54,1.43-1.08L280.6,109a3.41,3.41,0,0,1,1.42,2.72v3.26C282,116,281.38,116.47,280.6,116Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M267.51,120.82l-56.28-32.5a3.4,3.4,0,0,1-1.43-2.72V82.34c0-1,.64-1.54,1.43-1.08l56.28,32.49a3.43,3.43,0,0,1,1.43,2.73v3.26C268.94,120.79,268.3,121.27,267.51,120.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M304.72,231.84,210.8,177.62a3.42,3.42,0,0,1-1.42-2.73v-6.55c0-1.05.63-1.53,1.42-1.08l93.92,54.22a3.45,3.45,0,0,1,1.42,2.73v6.55C306.14,231.81,305.5,232.29,304.72,231.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M280.6,233.41l-69.37-40a3.43,3.43,0,0,1-1.43-2.73v-3.26c0-1.05.64-1.53,1.43-1.07l69.37,40a3.45,3.45,0,0,1,1.42,2.73v3.26C282,233.38,281.38,233.86,280.6,233.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M280.6,245.77l-69.37-40.05A3.42,3.42,0,0,1,209.8,203v-3.26c0-1,.64-1.53,1.43-1.07l69.37,40a3.45,3.45,0,0,1,1.42,2.73v3.26C282,245.74,281.38,246.22,280.6,245.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M267.51,250.57l-56.28-32.49a3.42,3.42,0,0,1-1.43-2.73v-3.26c0-1.05.64-1.53,1.43-1.07l56.28,32.49a3.43,3.43,0,0,1,1.43,2.73v3.26C268.94,250.55,268.3,251,267.51,250.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M329.85,247.94s10.36,8.7,25.32-3.18C365.85,236,375.4,241,380.72,244s13,4.84,27.63,31.26c0,0,4.76,8.28,12.62,12.82s11.64,2.32,17.82-7,10.23-19.64,21.59-12.9v93.69L328.83,286V247.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M301.26,208.22l-90-52a3.43,3.43,0,0,1-1.43-2.73V101.56c0-1,.64-1.53,1.43-1.08l90,52a3.43,3.43,0,0,1,1.43,2.73v51.95C302.69,208.19,302.05,208.67,301.26,208.22Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "328.83 245.76 328.83 285.98 460.38 361.92 460.38 268.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 380.53,
    y1: 244.47,
    x2: 380.53,
    y2: 315.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 420.78,
    y1: 289.54,
    x2: 420.78,
    y2: 338.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M328.83,247.33c23.34,14.47,26.64-18.24,52.07-3.56s21.92,33.81,40.69,44.65,19.21-31.5,38.79-20.19"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 380.53,
    cy: 244.47,
    rx: 2.53,
    ry: 4.39,
    transform: "translate(-71.26 223.03) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 460.38,
    cy: 268.23,
    rx: 2.53,
    ry: 4.39,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -72.43, 266.14)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 420.78,
    cy: 288.66,
    rx: 2.53,
    ry: 4.39,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -87.96, 249.08)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 328.83,
    cy: 247.33,
    rx: 2.53,
    ry: 4.39,
    transform: "translate(-79.61 197.56) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M332.54,178.23l-5.39-3.11a3.43,3.43,0,0,1-1.43-2.73v-26c0-1.05.64-1.53,1.43-1.08l5.39,3.12A3.4,3.4,0,0,1,334,151.1v26.05C334,178.2,333.33,178.68,332.54,178.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M345,185.4l-5.39-3.12a3.4,3.4,0,0,1-1.43-2.72v-53c0-1,.64-1.54,1.43-1.08L345,128.6a3.43,3.43,0,0,1,1.43,2.73v53C346.39,185.37,345.75,185.85,345,185.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M369.79,199.73l-5.39-3.11a3.4,3.4,0,0,1-1.43-2.73V146.05c0-1.05.64-1.53,1.43-1.08l5.39,3.11a3.43,3.43,0,0,1,1.43,2.73v47.85C371.22,199.71,370.58,200.19,369.79,199.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M382.21,206.9l-5.39-3.11a3.43,3.43,0,0,1-1.43-2.73V161.42c0-1,.64-1.53,1.43-1.08l5.39,3.12a3.4,3.4,0,0,1,1.43,2.72v39.64C383.64,206.88,383,207.36,382.21,206.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M406.94,221.18l-5.4-3.11a3.42,3.42,0,0,1-1.42-2.73V195.75c0-1.06.63-1.54,1.42-1.08l5.4,3.11a3.45,3.45,0,0,1,1.42,2.73V220.1C408.36,221.15,407.72,221.63,406.94,221.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M419.35,228.35,414,225.23a3.4,3.4,0,0,1-1.43-2.72V155.88c0-1.06.64-1.54,1.43-1.08l5.39,3.11a3.42,3.42,0,0,1,1.43,2.73v66.63C420.78,228.32,420.14,228.8,419.35,228.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M449.64,245.84l-5.39-3.12a3.4,3.4,0,0,1-1.43-2.72V220.4c0-1.05.64-1.53,1.43-1.08l5.39,3.12a3.4,3.4,0,0,1,1.43,2.73v19.59C451.07,245.81,450.43,246.29,449.64,245.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M462.06,253l-5.39-3.12a3.4,3.4,0,0,1-1.43-2.73v-26c0-1.05.64-1.53,1.43-1.08l5.39,3.11a3.43,3.43,0,0,1,1.43,2.73v26.05C463.49,253,462.85,253.46,462.06,253Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M104.91,498,60.27,472.26c-5.06-2.93-4.43-8,1.42-11.4l22.66-13.09C90.19,444.4,99,444,104.09,447l44.64,25.78c5.06,2.92,4.43,8-1.42,11.39l-22.66,13.09C118.81,500.58,110,501,104.91,498Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M172,465.87V403.56L76.68,392.83v62.7h0c-.06,1.92,1,3.75,3.4,5.11l44.64,25.78c5.06,2.92,13.9,2.55,19.74-.82l22.66-13.09c3.29-1.9,4.93-4.35,4.83-6.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M171.94,410.36l0-6.8h-7.33L123.9,380.05c-5.06-2.93-13.9-2.56-19.74.81L81.5,394a13.08,13.08,0,0,0-1.17.75l-3.65-1.87s0,7.19,0,7.43h0c-.06,1.9,1,3.73,3.4,5.09l44.64,25.77c5.06,2.92,13.9,2.55,19.74-.82l22.66-13.08c3.39-2,5-4.5,4.81-6.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M124.72,423.71,80.08,397.94c-5.06-2.92-4.43-8,1.42-11.4l22.66-13.08c5.84-3.38,14.68-3.74,19.74-.82l44.64,25.77c5.06,2.92,4.43,8-1.42,11.4l-22.66,13.08C138.62,426.27,129.78,426.63,124.72,423.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M114.66,388.53v-2.48h-1.52l-.47-.3a10.66,10.66,0,0,0-9.65,0,5.78,5.78,0,0,0-.81.57l-1.19-.27v2.48a3.4,3.4,0,0,0,2,2.79,10.66,10.66,0,0,0,9.65,0A3.37,3.37,0,0,0,114.66,388.53Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 107.84,
    cy: 386.05,
    rx: 6.82,
    ry: 3.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M131.58,399a4,4,0,0,1-1.83,1.93,10.7,10.7,0,0,1-9.64,0,4,4,0,0,1-1.83-1.93c-.5-1.28.12-2.65,1.83-3.65a10.7,10.7,0,0,1,9.64,0C131.47,396.3,132.08,397.67,131.58,399Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M131.58,399a4,4,0,0,1-1.83,1.93,10.7,10.7,0,0,1-9.64,0,1.94,1.94,0,0,1,0-3.87,10.7,10.7,0,0,1,9.64,0A4,4,0,0,1,131.58,399Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M147.61,407.87v-2.48h-1.52l-.47-.3a10.66,10.66,0,0,0-9.65,0,6.73,6.73,0,0,0-.81.56l-1.19-.26v2.48a3.4,3.4,0,0,0,2,2.79,10.66,10.66,0,0,0,9.65,0A3.37,3.37,0,0,0,147.61,407.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 140.79,
    cy: 405.39,
    rx: 6.82,
    ry: 3.94
  }), /*#__PURE__*/React.createElement("g", {
    id: "Men_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-24",
    d: "M65.3,378.51c-.27,2.33-3,12.39-2.46,15.84s10.1,9.21,10.1,9.21l1.32-5.9L69,392.5l1.42-9.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-25",
    d: "M72.65,368.6a4.15,4.15,0,0,0-5.29,1.59c-1.4,2.32-2.85,10.26-3,11.62,0,0,2,2.71,4.91,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M83.5,480.76a8.15,8.15,0,0,0,6.15-.75c1.48.05,9.53-3.4,10.62-.51,1,2.54-2.53,4.88-4.39,5.33-4.06,1-7.06,3-8.7,3.36-1.21.25-2.79.42-3.75-.54C82.26,486.51,82.36,482.27,83.5,480.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M87.18,487.48c1.64-.34,4.64-2.37,8.7-3.35,1.56-.38,4.25-2.08,4.52-4.12.36,2.33-2.78,4.4-4.52,4.82-4.06,1-7.06,3-8.7,3.36-1.21.25-2.79.42-3.75-.54a2.24,2.24,0,0,1-.54-1A4.84,4.84,0,0,0,87.18,487.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M70.46,474.9a8.15,8.15,0,0,0,6.15-.74c1.48,0,9.52-3.4,10.62-.51,1,2.53-2.53,4.87-4.39,5.33-4.06,1-7.07,3-8.7,3.35-1.22.25-2.79.42-3.76-.53C69.22,480.65,69.32,476.41,70.46,474.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M74.14,481.63c1.63-.35,4.64-2.37,8.7-3.36,1.56-.37,4.25-2.08,4.52-4.11.36,2.33-2.78,4.39-4.52,4.82-4.06,1-7.07,3-8.7,3.35-1.22.25-2.79.42-3.76-.53a2.41,2.41,0,0,1-.53-1A4.89,4.89,0,0,0,74.14,481.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_3",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-5",
    d: "M70.3,453.05a49.26,49.26,0,0,1,1.85-8.81s-.55-7.6-.83-14.81c-.31-8.18-3.15-15.38-.91-21.9l25.23,5.61s-1.52,32.61-1.86,36.55a73,73,0,0,1-1.13,9.16c-1.15,6.33-3,21.39-3,21.39-2.66,1.55-6.17.69-6.17.69s.2-19,.37-23.6c.21-5.57.38-5.15.38-5.15l-.84-13.87-.54-6.9s-.7,5.06-1.16,9.59c-.39,3.94-1.34,7.51-2.41,14.85-.92,6.37-2.42,19.17-2.42,19.17-2.67,1.55-6.29.26-6.29.26S69.58,458.57,70.3,453.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_4",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-24",
    d: "M74,368.73c1.93.1,3.36.59,3.6,0a26.56,26.56,0,0,0,.43-3c-.22-.56-.41-1.16-.41-1.16-2.41-1.48-3.17-4.09-3.49-7.13-.54-5.19,2.26-9.73,7.45-10.27,4.88-.51,8.48,2.92,9.43,7.63.52,2.32,1.55,6.72.16,10.54-.78,2.14-1.78,3.84-2.78,4.17a25.37,25.37,0,0,1-2.89-.26h0s-.26,1.44-.44,2.36-.11,1.42,1.73,2.55S84,377.66,81,377.43s-6.42-2.05-7.36-4C72.57,371.24,72.66,368.67,74,368.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-28",
    d: "M76.76,369c-.53,1.33.82,3,4.43,4.08s3.94-.32,3.94-.32a71.34,71.34,0,0,1,7,3.61c2.17,1.52,3.13,5.9,3.42,13.3.34,8.56.37,21.26.08,23.45,0,0-4,4-9.23,3.61s-13.89-5-16-8.55c.06-7.51.94-8.73-.28-13.05-2.78-9.9-4.24-14-2.89-20.53,1.11-5.43,2.67-6.1,4.82-6.05A43,43,0,0,1,76.76,369Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_6",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-24",
    d: "M103.71,396.77c-4.26,1.07-5.25-1.61-5.81-3.83-1.36-5.38-2.08-10.23-3.09-13.28-1.19-3.6-2.44-4.17-4.18-4.87-2-.83-3.82.91-3.14,5.49a91.73,91.73,0,0,0,3.9,15.63c.53,1.67,1.71,4.64,3.49,6.08,2.19,1.77,5.5,1.7,10.5.46,2.13-.54,4.47-1.81,8.5-3.69,1.08-.5,1.92-.84,4-1.81a14.06,14.06,0,0,0,5.33-4.16c1.09-1.58,1.23-2.32,1-2.68s-.77-.35-1.35.32a11.66,11.66,0,0,1-3.06,2.83s1.34-1.39,2.07-2.29a11.51,11.51,0,0,0,1.61-2.63c.38-.92-.41-2.17-1-1.51s-.89,1.32-2,2.64a11.41,11.41,0,0,1-2,1.88,20.81,20.81,0,0,0,1.81-2.92,4.85,4.85,0,0,0,.67-2.64c0-.48-.71-1.05-1.35-.14a17.45,17.45,0,0,1-2.28,3.49c-1,1-1.8,1.58-1.82,1.3s.58-.83.93-2,0-2.42-.65-2.55-.52-.1-1,1a31.81,31.81,0,0,0-1.93,3.51,7.33,7.33,0,0,1-1.75,3C110.06,394.52,107.75,395.75,103.71,396.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_7",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-25",
    d: "M89.05,374.05c2.84-.42,4.85.86,6.1,5.16S97.28,387,97.28,387a7.72,7.72,0,0,1-4.75,3.16c-3.4.83-4.62-.8-4.62-.8s-.94-4.5-1.53-7.57S85.54,374.57,89.05,374.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M90.83,354.13s4.48-6.82-5.24-8.21c-7-1-11.51,3.5-12,8.39-.5,4.67,2.38,9.52,4.45,11.44a8.46,8.46,0,0,0,6.06-.73,33.62,33.62,0,0,0,.14-3.82S80.79,354,90.83,354.13Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 382.58,
    cy: 470.58,
    rx: 24.63,
    ry: 14.22
  }), /*#__PURE__*/React.createElement("g", {
    id: "Girl_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-29",
    d: "M382.37,333.37c1-1.63,8.8-2.71,11.36,3.88,1,2.5.82,8.89,1.63,12.9s2.72,6.29,3.41,9.54-.43,8.71-8.28,9.68-13.88-1.79-15.73-4.29-1.89-7.82,0-10.68,3.39-5.17,3.34-8.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_9",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-29",
    d: "M387.51,332.24s-5.86-1.69-9.41,1.47a8.72,8.72,0,0,0-2.5,8.68c.47,1.85,1.42,4.37,2.89,4.51S387.51,332.24,387.51,332.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_10",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-24",
    d: "M389.75,348.21s-.39,6.52-.27,7,2.56,1,3.25,1.52-3.55,7.19-5.7,8.17-8.82-1.53-9.29-4.84c-.42-3.06,1.91-5.43,2.81-6.26a13.7,13.7,0,0,1,1.84-.05l.2-3.16C385.51,349.66,389.75,348.21,389.75,348.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M374,360.54c0-.19-1,.34-1,.35s-.47,16.75-1.29,18.27h0c-2.09,3.55-7.62,9.57-7.76,10.24-.41,2,.77.21,2.67,0,1.07-.13,7.36-6.49,8.77-7.94l.09.05,0-.16.18-.19a8.66,8.66,0,0,0,0-1.36C378.31,361.61,375.09,360.4,374,360.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-28",
    d: "M390.64,355.85c1.84.28,3.93,1.26,4.22,2.26a21.72,21.72,0,0,1-.52,10.9c-1.59,4.2-2.66,6.87-3.58,8.68,0,0-7.93,3.4-14.33-.57,0,0-.44-4.5-.47-6.91-5.9-5.15-.85-11.5,4.15-16.43a9.87,9.87,0,0,1,1.8,0s-4.46,5.28-1.36,8.28C387.2,360,388.52,357,390.64,355.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-24",
    d: "M377.56,340.12h0c.65-4.19,3.68-7.36,8-7.11a8.31,8.31,0,0,1,4.18,15.2,8.12,8.12,0,0,1-.67,1.83c-1.53,1.78-5.6,2.91-6.94,2.93-1.16,0-2.16-1.07-3.25-2.87C376.62,346.35,377.2,342.19,377.56,340.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M386.91,333.09c3,.59,5.52,1.45,6.35,4.42.56,2.06,1.3,6,.6,7.61l-.44,1.19-3.67,1.9s-1.72-1.43-1.18-5.62a3,3,0,0,0-.52-1.58,4.82,4.82,0,0,1-.51-1.27,4.76,4.76,0,0,0-2.38-2.58c-2.73-1.53-6.73-.21-7.29.35A8,8,0,0,1,386.91,333.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M392.43,465.69c-1.54,1.25-3.93.39-4,.5a63.72,63.72,0,0,1-5.62,4.3c-1,.75-2.45,1.76-2.18,3.2.48,2.59,4.62,1.8,6.18,1s2.84-2.1,4.32-3c1.05-.65,2.09-1,2.26-2.32C393.44,468.54,392.7,465.66,392.43,465.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M393.33,468.81c-.21,1.28-1.23,1.63-2.28,2.28-1.5.93-2.82,2.28-4.38,3.07s-5.05,1.45-6.06-.39c.55,2.49,4.62,1.71,6.16.92s2.84-2.1,4.32-3c1.05-.65,2.09-1,2.26-2.32A3.6,3.6,0,0,0,393.33,468.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M381.66,463.54c-1.41,1.15-3.53.5-3.63.61a61.13,61.13,0,0,1-5.14,3.92c-.88.69-2.25,1.61-2,2.93.44,2.37,4.23,1.64,5.67.92s2.59-1.93,3.95-2.77c1-.6,1.91-.91,2.06-2.13C382.67,466.28,381.91,463.51,381.66,463.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M382.56,466.53c-.19,1.17-1.13,1.49-2.09,2.08-1.37.86-2.58,2.09-4,2.82s-4.62,1.33-5.55-.36c.5,2.28,4.23,1.57,5.65.85s2.59-1.93,3.95-2.77c1-.6,1.91-.91,2.06-2.13A2.06,2.06,0,0,0,382.56,466.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M373.38,392.14c.68-5.3,2.63-13,2.63-13a15.62,15.62,0,0,0,5.87,1.45,48,48,0,0,0,8.88-.86,52.72,52.72,0,0,0,3.13,4.84c1.53,2.12,4.5,6.76,3.78,14.87-.47,5.3-3.44,27.81-3.44,27.81a42,42,0,0,1,1.83,11.67,97.41,97.41,0,0,1-1.86,14l-1.77,12.77s-2.36,1.71-4,.5l.21-12.5c-.2-3.06-.51-7.57-.7-10.45-.32-4.7-1.16-12.15-1.4-14s-.84-5.12-1.13-8.76-1.65-22.17-1.65-22.17l-.19,3.47s-.19,5.63-1,12.58-1.09,10-1.09,10a14.88,14.88,0,0,1,1.59,4.49c.14,1.5,1.85,13.38.83,19.42l-2.11,15.37a4,4,0,0,1-3.63.48l-1.24-15.49c-.83-5.89-2.59-18.38-2.86-20a66.69,66.69,0,0,1-1.06-9.91C372.56,412,372.7,397.43,373.38,392.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M390.76,377.69l4.56,9.15s7,10.18-.25,36.35l1.35,8.08s-13.64,8.75-22.77,0c0,0-3.16-24.19-1.48-35.34A129.16,129.16,0,0,1,376.42,377s2.24,2.47,13.74.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M380.11,353.78s-3.62-1.11-7.47,6.92l1.44.86S377.87,355.84,380.11,353.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "351.84 397.29 367.42 388.24 378.6 394.69 363.02 403.75 351.84 397.29"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M365.41,388.9a6.85,6.85,0,0,0-2.77.9,7.13,7.13,0,0,1-1,.73c-.15.07-.3.17-.46.24a1.68,1.68,0,0,0-.63.41,1.57,1.57,0,0,0-.27.87,3.58,3.58,0,0,0-.06,1.13c.14.56.72.51,1,.12a1.19,1.19,0,0,0,.25-.68,1.5,1.5,0,0,1,.66-1.19l3.72-2.31A.44.44,0,0,0,365.41,388.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M395.05,361c-.51-2.12-2.17-1.44-3.6-2.68-3.31,4.69-1.11,17.37-.66,18.72l-12.72,8.11h0l-.86.53a15.2,15.2,0,0,1-4.73,2.06c-1.27.15-1.93,1.94-3.29,2.1a.53.53,0,0,0-.35.91c.54.52,2,.09,3-1.07a.22.22,0,0,0,0,.08,1.08,1.08,0,0,0,.56.9.57.57,0,0,0,.24.08.44.44,0,0,0,.07.24,1,1,0,0,0,.76.55h0a1,1,0,0,0,1,.67,1.15,1.15,0,0,0,.77-.35,6.68,6.68,0,0,0,2.78-2,26,26,0,0,1,2.06-1.92c3.45-1.49,13.8-5.91,14.26-6.54C395.06,380.44,395.79,364,395.05,361Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M396.21,366.69s-4.07,1.82-7.45.12l.49-6.37s.05-3.42,3.1-3.76S397,360.25,396.21,366.69Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartupSvg);
export default __webpack_public_path__ + "static/media/Startup_SVG.d6335a121e2537da0d9613dbf9852729.svg";
export { ForwardRef as ReactComponent };